import { authorSlugs } from '~/constants/author-slugs';

export function useArticleAuthors(crew) {
  if (!crew) return [];
  return crew
    .filter(({ speciality }) => authorSlugs.includes(speciality.slug.current))
    .map(({ staff }) => staff);
}
